import { render, staticRenderFns } from "./Omoss.vue?vue&type=template&id=f4ca403c&scoped=true&"
import script from "./Omoss.vue?vue&type=script&lang=js&"
export * from "./Omoss.vue?vue&type=script&lang=js&"
import style0 from "./Omoss.vue?vue&type=style&index=0&id=f4ca403c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ca403c",
  null
  
)

export default component.exports